export const COMPARE_ENABLED_CONFIG = 'Newbuilding.Compare.Enabled';
export const COMPARE_ONBOARDING_ENABLED_CONFIG = 'Newbuilding.CompareOnboarding.Enabled';
export const COMPARE_ONBOARDING_COOKIE_NAME = 'frontend-serp.compare_onboarding_shown';
export const SHOW_ONBOARDING_DELAY_MS = 1000;
export const AUTO_CLOSE_ONBOARDING_DELAY_MS = 15000;
export const TRUTHY_COOKIE_CONTENT = '1';
export const COMPARE_BUTTON_DATA_MARK = 'CompareButton';
export const ADD_TO_COMPARE_TOOLTIP = 'Добавить к сравнению';
export const REMOVE_FROM_COMPARE_TOOLTIP = 'Удалить из сравнения';
export const ADD_TO_COMPARE_LABEL = 'Добавить к сравнению';
export const REMOVE_FROM_COMPARE_LABEL = 'Удалить из сравнения';
